import React from 'react';
import classes from './HLLine.module.scss'

const HLLine = () => {
    return (
        <div className={classes.line}></div>
    );
};

export default HLLine;